<template>
    <div ref="container">
      <a-modal :title="title" width="96%" height="90%" :visible="visible" :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()"
      :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:1%;height: 70%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报告单号" prop="recordCode">
                  <a-input placeholder="请输入报告单号" v-model="form.recordCode"/>
                  <!-- onblur="isRepeat" -->
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报告日期" prop="date">
                  <JDate placeholder="请填写报告日期" v-model="form.date" ></JDate>
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="受理人" prop="acceptedBy">
                  <a-input placeholder="请输入受理人" v-model="form.acceptedBy" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编号" prop="productNumber">
                  <a-input placeholder="请输入产品编号" v-model="form.productNumber" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称" prop="productName">
                  <a-input placeholder="请输入产品名称" v-model="form.productName" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格型号" prop="productModel">
                  <a-input placeholder="请输入规格型号" v-model="form.productModel" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品注册证号" prop="productRegistrationNumber">
                  <a-input placeholder="请输入产品注册证号" v-model="form.productRegistrationNumber" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册人/备案人" prop="regBy">
                  <a-input placeholder="请输入注册人/备案人" v-model="form.regBy" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产企业许可证" prop="productionEnterpriseLicense">
                  <a-input placeholder="请输入生产企业许可证" v-model="form.productionEnterpriseLicense" />
                </a-form-model-item>
              </a-col>
              
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="批号/序列号" prop="serialNumber">
                  <a-input placeholder="请输入批号/序列号" v-model="form.serialNumber" />
                </a-form-model-item>
              </a-col>
              
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产日期" prop="productData">
                  <JDate placeholder="请填写报告日期" v-model="form.productData" ></JDate>
                </a-form-model-item>
              </a-col>
              
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉方单位" prop="complaint">
                  <a-input placeholder="请输入投诉方单位" v-model="form.complaint" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉方联系人" prop="complaintContacts">
                  <a-input placeholder="请输入投诉方联系人" v-model="form.complaintContacts" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉方联系电话" prop="complaintPhoneNumber">
                  <a-input placeholder="请输入投诉方联系电话" v-model="form.complaintPhoneNumber" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供货方单位" prop="supplier">
                  <a-input placeholder="请输入供货方单位" v-model="form.supplier" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供货方联系人" prop="supplierContacts">
                  <a-input placeholder="请输入供货方联系人" v-model="form.supplierContacts" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供货方联系电话" prop="supplierPhoneNumber">
                  <a-input placeholder="请输入供货方联系电话" v-model="form.supplierPhoneNumber" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报告人" prop="preparedBy">
                  <a-input placeholder="请输入报告人" v-model="form.preparedBy" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="批准人" prop="approveBy">
                  <a-input placeholder="请输入批准人" v-model="form.approveBy" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题描述" prop="problemRemark">
                  <a-textarea placeholder="请输入问题描述" v-model="form.problemRemark" :autoSize="{ minRows: 3 }"></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="事故原因" prop="reason">
                  <a-textarea placeholder="请输入事故原因" v-model="form.reason" :autoSize="{ minRows: 3 }"></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="整改措施" prop="measure">
                  <a-textarea placeholder="请输入整改措施" v-model="form.measure" :autoSize="{ minRows: 3 }"></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="责任部门" prop="responsibleDepartment">
                  <a-textarea placeholder="请输入责任部门" v-model="form.responsibleDepartment" :autoSize="{ minRows: 3 }"></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="批准意见" prop="opinion">
                  <a-textarea placeholder="请输入批准意见" v-model="form.opinion" :autoSize="{ minRows: 3 }"></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
                  <a-textarea placeholder="请输入备注" v-model="form.remark" :autoSize="{ minRows: 3 }"></a-textarea>
                </a-form-model-item>
              </a-col>
              <!-- <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                  <j-image-upload v-model="fileList" bizPath="material" text="上传" isMultiple></j-image-upload>
                </a-form-model-item>
              </a-col> -->
            </a-row>
          </a-form-model>
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import pick from 'lodash.pick'
  import { generateQualityCode, editQuality, addQuality, } from '@/api/api'
  import { autoJumpNextInput } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
import JDate from '../../../components/jeecg/JDate.vue'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
        JImageUpload,
        JDate,
    },
    data() {
      return {
        title: '操作',
        visible: false,
        fileList: '',
        model: {},
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        form: {
          recordCode: '',
        },
        uploadHeaders: {},
        action: window._CONFIG['domianURL'] + '/systemConfig/upload',
        rules: {
          recordCode: [{ required: true, message: '请输入报告编号' }],
          date: [{ required: true, message: '请选择报告日期' }],
        },
        id: '',
      }
    },
    created() {},
    methods: {
      //单据编号验重
      isRepeat(){
        console.log('000')
      },
      add() {
        this.generateQualityCode()
        this.edit({})
        this.id = ''
      },
      edit(record) {
        if (this.$refs.form !== undefined) this.$refs.form.resetFields()
        console.log(this.form, 'form')
        console.log(this.fileList, '数组')
        if (record.id) {
          this.id = record.id
          this.form = { ...this.form, ...record } // 合并保留初始字段
        } else {
          this.fileList = ''
          // 重置表单但保留初始结构
          this.form = Object.assign({}, this.$options.data().form)
        }
        this.visible = true
        this.$nextTick(() => {})
      },
      
      // 生成单号
      generateQualityCode(){
        generateQualityCode().then(res => {
          if (res.code == 200 && res.success == true) {
            this.form.recordCode = res.result
            // this.$set(this.form, 'recordCode', res.result)
          } else {
            this.$message.error(res.message)
          }
        })
        // const res = await generateCode()
        // if ( res.code == 200 && res.success == true){
        //   this.form.code = res.result
        //   this.$set(this.form, 'code', res.result)
        // }

      },
      handleChange({ file, fileList }) {
        console.log(file, 'file')
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            console.log(this.form, 'form---')
            // console.log(this.fileList, '图片数组')
            // if (this.fileList.length == 0) return this.$message.warning('请上传至少一张图片')
            let params = {
              recordCode: this.form.recordCode || '',
              date: this.form.date || '',
              preparedBy: this.form.preparedBy || '',
              acceptedBy: this.form.acceptedBy || '',
              productNumber: this.form.productNumber || '',
              productName: this.form.productName || '',
              productModel: this.form.productModel || '',
              productRegistrationNumber: this.form.productRegistrationNumber || '',
              regBy: this.form.regBy || '',
              productionEnterpriseLicense: this.form.productionEnterpriseLicense || '',
              serialNumber: this.form.serialNumber || '',
              productData: this.form.productData || '',
              complaint: this.form.complaint || '',
              complaintContacts: this.form.complaintContacts || '',
              complaintPhoneNumber: this.complaintPhoneNumber || '',
              supplier: this.form.supplier || '',
              supplierContacts: this.form.supplierContacts || '',
              supplierPhoneNumber: this.form.supplierPhoneNumber || '',
              approveBy: this.form.approveBy || '',
              problemRemark: this.form.problemRemark || '',
              reason: this.form.reason || '',
              measure: this.form.measure || '',
              responsibleDepartment: this.form.responsibleDepartment || '',
              opinion: this.form.opinion || '',
              remark: this.form.remark || '',
            }
            if (this.id) {
              // 编辑
              params.id = this.id
              const res = await editQuality(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.handleCancel()
                this.$emit('ok')
              } else {
                this.$message.error(res.data || res.message)
              }
            } else {
              const res = await addQuality(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.close()
                this.$emit('ok')
              } else {
                this.$message.error(res.data || res.message)
              }
            }
          }
        })
      },
      handleCancel() {
        this.close()
      },
      validateSupplierName(rule, value, callback) {
        let params = {
          name: value,
          type: '供应商',
          id: this.model.id ? this.model.id : 0,
        }
        checkSupplier(params).then((res) => {
          if (res && res.code === 200) {
            if (!res.data.status) {
              callback()
            } else {
              callback('名称已经存在')
            }
          } else {
            callback(res.data)
          }
        })
      },
    },
  }
  </script>
  <style scoped>
  </style>